export default {
    'Intelligent-Categorization-Import': 'Metafields Import',
    'Click or drag file to this area to upload': 'Click or drag file to this area to upload',
    'upload info': 'Please upload files in Excel format. It is strictly prohibited to upload any other prohibited files.',
    'Or paste your file link': 'Or paste your file link',
    'Import': 'Import',
    'Help': 'Help',
    'Steps': 'Steps',
    'Download Template': 'Download Template',
    'Prepare data according to the template': 'Prepare data according to the template',
    'Upload your prepared data': 'Upload your prepared data',
    'The system is executing the import': 'The system is executing the import',
    'Operation completed': 'Operation completed',
    'Contact us': 'Contact us',
    'If you have any questions or suggestions, please feel free to contact us': 'If you have any questions or suggestions, please feel free to contact us',
    'Phone': 'Phone',
    'Smart Categorization Import': 'Metafields Import',
    'Download Template Now': 'Download Template Now',
    'help.doc.title': 'Help document',
    'Export': 'Export',
    'Smart categorization': 'Metafields Import',
    'Click a button to export smart categorization data': 'Click a button to export smart categorization data',
    'Custom Collections':'Custom Collections',
    "Export manually classified IDs": "Export manually classified IDs",
    "Smart Collections": "Smart Collections",
    "Export smart classified IDs": "Export smart classified IDs",
    "Exporting products": "Exporting products",
    "Exporting product ID and variant ID": "Exporting product ID,variant ID",
    
    // 新增的翻译
    'Home': 'Home',
    'Welcome': 'Welcome to Smart Import System',
    'Please select the function you want to use': 'Please select the function you want to use',
    'Metafields Import': 'Metafields Import',
    'Import metafields data to your store': 'Import metafields data to your store',
    'Product Template Import': 'Product Template Import',
    'Batch import product templates and collections': 'Batch import product templates and collections',
    'Operation Logs': 'Operation Logs',
    'View operation logs and task status': 'View operation logs and task status',
    'Recent Activity': 'Recent Activity',
    'No recent activity': 'No recent activity',
    'Smart Import System': 'Smart Import System',
    
    // 产品导入页面
    'Collection Template Import': 'Collection Template Import',
    'Support CSV, Excel format files': 'Support CSV, Excel and CSV format files',
    'Task Status': 'Task Status',
    'Task ID': 'Task ID',
    'Type': 'Type',
    'Status': 'Status',
    'Created Time': 'Created Time',
    'Action': 'Action',
    'Refresh': 'Refresh',
    'Product Import Steps': 'Product Import Steps',
    'Download product template': 'Download product template',
    'Prepare product data according to template': 'Prepare product data according to template',
    'Upload prepared product file': 'Upload prepared product file',
    'Wait for import completion': 'Wait for import completion',
    'Download Product Template': 'Download Product Template',
    'Collection Import Steps': 'Collection Import Steps',
    'Download collection template': 'Download collection template',
    'Prepare collection data according to template': 'Prepare collection data according to template',
    'Upload prepared collection file': 'Upload prepared collection file',
    'Download Collection Template': 'Download Collection Template',
    'Please enter file URL': 'Please enter file URL',
    'Task submitted successfully': 'Task submitted successfully',
    'Import failed': 'Import failed',
    'Product template download feature coming soon': 'Product template download feature coming soon',
    'Collection template download feature coming soon': 'Collection template download feature coming soon',
    
    // 新增任务状态相关翻译
    'File URL': 'File URL',
    'Progress': 'Progress',
    'Results': 'Results',
    'Total': 'Total',
    'COMPLETED': 'Completed',
    
    // 日志页面
    'Total Logs': 'Total Logs',
    'Success': 'Success',
    'Failed': 'Failed',
    'Pending': 'Pending',
    'Filter': 'Filter',
    'Resource Type': 'Resource Type',
    'All': 'All',
    'Product': 'Product',
    'Collection': 'Collection',
    'Start Time': 'Start Time',
    'End Time': 'End Time',
    'Select start time': 'Select start time',
    'Select end time': 'Select end time',
    'Search': 'Search',
    'Reset': 'Reset',
    'Cleanup Old Logs': 'Cleanup Old Logs',
    'Log List': 'Log List',
    'ID': 'ID',
    'Resource ID': 'Resource ID',
    'Error Message': 'Error Message',
    'View Detail': 'View Detail',
    'None': 'None',
    'No details': 'No details',
    'Log Detail': 'Log Detail',
    'Details': 'Details',
    'Updated Time': 'Updated Time',
    'Confirm': 'Confirm',
    'Are you sure to cleanup old logs? This action cannot be undone.': 'Are you sure to cleanup old logs? This action cannot be undone.',
    'Cleanup completed': 'Cleanup completed',
    'Cleanup failed': 'Cleanup failed',
    'PENDING': 'Pending',
    'PROCESSING': 'Processing',
    'STALLED': 'Possibly Stalled',
    'SUCCESS': 'Success',
    'FAILED': 'Failed',
    'Task may be stalled': 'Task may be stalled',
    'Task processing time exceeded threshold, please retry this file if status does not change': 'Task processing time exceeded threshold, please retry this file if status does not change',
    'PRODUCT': 'Product',
    'COLLECTION': 'Collection',
    
    // 价格页面
    'Pricing Plans': 'Pricing Plans',
    'Choose the plan that fits your business needs': 'Choose the plan that fits your business needs',
    'Usage Limit Exceeded': 'Usage Limit Exceeded',
    'You have exceeded your monthly usage limit': 'You have exceeded your monthly usage limit',
    'Recommended': 'Recommended',
    'Free Plan': 'Free Plan',
    'Basic Plan': 'Basic Plan',
    'Professional Plan': 'Professional Plan',
    'Enterprise Plan': 'Enterprise Plan',
    'month': 'month',
    'Current Plan': 'Current Plan',
    'Select Plan': 'Select Plan',
    'Feature Comparison': 'Feature Comparison',
    'Feature': 'Feature',
    'Need Help Choosing?': 'Need Help Choosing?',
    'Contact us for personalized recommendations and enterprise solutions': 'Contact us for personalized recommendations and enterprise solutions',
    'Contact Sales': 'Contact Sales',
    'Monthly 10 uses limit': 'Monthly 10 uses limit',
    'Basic functionality support': 'Basic functionality support',
    'Metafields import only (no export)': 'Metafields import only (no export)',
    'Community support': 'Community support',
    'Monthly 100 uses limit': 'Monthly 100 uses limit',
    'All features except collection updates': 'All features except collection updates',
    'Includes metafields export': 'Includes metafields export',
    'Email support': 'Email support',
    'Unlimited usage': 'Unlimited usage',
    'All features support': 'All features support',
    'Priority technical support': 'Priority technical support',
    'API access': 'API access',
    'Dedicated customer service': 'Dedicated customer service',
    'Custom development': 'Custom development',
    'SLA guarantee': 'SLA guarantee',
    'Usage Limit': 'Usage Limit',
    '10/month': '10/month',
    '100/month': '100/month',
    'Unlimited': 'Unlimited',
    'Metafields Import': 'Metafields Import',
    'Product Import': 'Product Import',
    'Collection Import': 'Collection Import',
    'API Access': 'API Access',
    'Support Level': 'Support Level',
    'Community': 'Community',
    'Email': 'Email',
    'Priority': 'Priority',
    'Dedicated': 'Dedicated',
    'You are currently on the free plan': 'You are currently on the free plan',
    'Plan upgrade request submitted': 'Plan upgrade request submitted',
    'Please contact our sales team for subscription': 'Please contact our sales team for subscription',
    'Monthly usage limit exceeded': 'Monthly usage limit exceeded. Current usage: {current}/{limit}, This request: {request}',
    'Upgrade your plan to continue': 'Upgrade your plan to continue using our services',
    'View Pricing': 'View Pricing',
    'Cancel': 'Cancel',
    'Current usage': 'Current usage',
    'This request': 'This request',
    
    // 支付页面
    'Payment': 'Payment',
    'Selected Plan': 'Selected Plan',
    'Included Features': 'Included Features',
    'Payment Methods': 'Payment Methods',
    'Alipay': 'Alipay',
    'WeChat Pay': 'WeChat Pay',
    'Scan QR code to pay with Alipay': 'Scan QR code to pay with Alipay',
    'Scan QR code to pay with WeChat': 'Scan QR code to pay with WeChat',
    'Need Help?': 'Need Help?',
    'Customer Service WeChat': 'Customer Service WeChat',
    'Contact our customer service for:': 'Contact our customer service for:',
    'Contact our customer service for payment confirmation and account activation': 'Contact our customer service for payment confirmation and account activation',
    'Payment confirmation': 'Payment confirmation',
    'Account activation': 'Account activation',
    'Technical support': 'Technical support',
    'Refund requests': 'Refund requests',
    'Payment Instructions': 'Payment Instructions',
    '1. Please include your email address in the payment note': '1. Please include your email address in the payment note',
    '2. Account will be activated within 24 hours after payment confirmation': '2. Account will be activated within 24 hours after payment confirmation',
    '3. Contact customer service if you need immediate activation': '3. Contact customer service if you need immediate activation',
    '4. Refunds are available within 7 days if unsatisfied': '4. Refunds are available within 7 days if unsatisfied',
    'Back to Pricing': 'Back to Pricing',
    
    // 日志页面新增翻译
    'Operation': 'Operation',
    'None': 'None',
    'No details': 'No details',
    'Log Detail': 'Log Detail',
    'Log List': 'Log List',
    'Select start time': 'Select start time',
    'Select end time': 'Select end time',
    'Cleanup Old Logs': 'Cleanup Old Logs',
    'Are you sure to cleanup old logs? This action cannot be undone.': 'Are you sure to cleanup old logs? This action cannot be undone.',
    'Cleanup completed': 'Cleanup completed',
    'Cleanup failed': 'Cleanup failed',
    'Handle': 'Handle',
    'Request Data': 'Request Data',
    'Response Data': 'Response Data',
    'UPDATE': 'Update',
    'CREATE': 'Create',
    'DELETE': 'Delete',
    'Success Rate': 'Success Rate',
    'Products': 'Products',
    'Collections': 'Collections',
    'Pricing Plans': 'Pricing Plans',
    'View our pricing plans and upgrade': 'View our pricing plans and upgrade',
    'Support Excel format files (.xlsx)': 'Support Excel format files (.xlsx)',
    'Metafields Import Steps': 'Metafields Import Steps',
    'Download metafields template': 'Download metafields template',
    'Prepare metafields data according to template': 'Prepare metafields data according to template',
    'Upload prepared metafields file': 'Upload prepared metafields file',
    'Wait for import completion': 'Wait for import completion',
    'Download Metafields Template': 'Download Metafields Template',
    'Template Format': 'Template Format',
    'Excel file with 8 columns:': 'Excel file with 8 columns:',
    'products/variants': 'products/variants',
    'Product/Variant ID': 'Product/Variant ID',
    'Parent Product ID (for variants)': 'Parent Product ID (for variants)',
    'Metafield namespace': 'Metafield namespace',
    'Metafield key': 'Metafield key',
    'Metafield type': 'Metafield type',
    'Description': 'Description',
    'Metafield value': 'Metafield value',
    'View Logs': 'View Logs',
    'Statistics': 'Statistics',
    'Import Logs': 'Import Logs',
    'Import Statistics': 'Import Statistics',
    'Row Number': 'Row Number',
    'Owner Resource': 'Owner Resource',
    'Owner ID': 'Owner ID',
    'Namespace': 'Namespace',
    'Key': 'Key',
    'Total Records': 'Total Records',
    'Success Count': 'Success Count',
    'Failed Count': 'Failed Count',
    'Start Time': 'Start Time',
    'End Time': 'End Time',
    'Template download started': 'Template download started',
    'Template download failed': 'Template download failed',
    'Please refer to the template format in help section': 'Please refer to the template format in help section',
    'Metafields Import': 'Metafields Import',
    'Import metafields data to your store': 'Import metafields data to your store',
    'Product template download started': 'Product template download started',
    'Collection template download started': 'Collection template download started',
    'Download product template': 'Download product template',
    'Download collection template': 'Download collection template',
    'Prepare product data according to template': 'Prepare product data according to template',
    'Download Product Template': 'Download Product Template',
    'Download Collection Template': 'Download Collection Template',
    'No statistics data available': 'No statistics data available',
    'Failed to load statistics': 'Failed to load statistics',
    'View Field Guide': 'View Field Guide',
    'Metafield Field Guide': 'Metafield Field Guide',
    'The resource type that the metafield belongs to. Valid enum values include:': 'The resource type that the metafield belongs to. Valid enum values include:',
    'Product variants': 'Product variants',
    'Product collections': 'Product collections',
    'Customers': 'Customers',
    'Orders': 'Orders',
    'Pages': 'Pages',
    'Blog collections': 'Blog collections',
    'Blog articles': 'Blog articles',
    'Shop': 'Shop',
    'Metafield Type': 'Metafield Type',
    'Data types supported by metafields. Valid enum values include:': 'Data types supported by metafields. Valid enum values include:',
    'Text Types': 'Text Types',
    'Single line text': 'Single line text',
    'Multiple single line texts': 'Multiple single line texts',
    'Multi-line text': 'Multi-line text',
    'Color Types': 'Color Types',
    'Single color': 'Single color',
    'Multiple colors': 'Multiple colors',
    'Date Types': 'Date Types',
    'Single date': 'Single date',
    'Multiple dates': 'Multiple dates',
    'Single date and time (ISO 8601 format)': 'Single date and time (ISO 8601 format)',
    'Multiple dates and times (ISO 8601 format)': 'Multiple dates and times (ISO 8601 format)',
    'URL Types': 'URL Types',
    'Single URL': 'Single URL',
    'Multiple URLs': 'Multiple URLs',
    'File Types': 'File Types',
    'Single file (PDF, JPG, JPEG, PNG, GIF up to 10MB)': 'Single file (PDF, JPG, JPEG, PNG, GIF up to 10MB)',
    'Multiple files (PDF, JPG, JPEG, PNG, GIF up to 10MB)': 'Multiple files (PDF, JPG, JPEG, PNG, GIF up to 10MB)',
    'Number Types': 'Number Types',
    'Single integer': 'Single integer',
    'Multiple integers': 'Multiple integers',
    'Single decimal': 'Single decimal',
    'Multiple decimals': 'Multiple decimals',
    'Measurement Types': 'Measurement Types',
    'Single weight with unit': 'Single weight with unit',
    'Multiple weights with units': 'Multiple weights with units',
    'Single volume with unit': 'Single volume with unit',
    'Multiple volumes with units': 'Multiple volumes with units',
    'Single dimension with unit': 'Single dimension with unit',
    'Multiple dimensions with units': 'Multiple dimensions with units',
    'Reference Types': 'Reference Types',
    'Single page reference': 'Single page reference',
    'Multiple page references': 'Multiple page references',
    'Single product reference': 'Single product reference',
    'Multiple product references': 'Multiple product references',
    'Single variant reference': 'Single variant reference',
    'Multiple variant references': 'Multiple variant references',
    'Single collection reference': 'Single collection reference',
    'Multiple collection references': 'Multiple collection references',
    'Single customer reference': 'Single customer reference',
    'Multiple customer references': 'Multiple customer references',
    'Single order reference': 'Single order reference',
    'Multiple order references': 'Multiple order references',
    'Other Types': 'Other Types',
    'JSON type': 'JSON type',
    'Single rating': 'Single rating',
    'Multiple ratings': 'Multiple ratings',
    'Boolean type (true/false)': 'Boolean type (true/false)',
    'Money with currency unit': 'Money with currency unit',
    'Value Format Guide': 'Value Format Guide',
    'Different metafield types require different value formats. See the table below:': 'Different metafield types require different value formats. See the table below:',
    'list type prerequisite title': '⚠️ list.* types require a pre-created metafield definition',
    'list type prerequisite desc': 'For all list.* types (e.g. list.single_line_text_field), you must first create the corresponding metafield definition in the Shopline Admin → Settings → Custom Data, and set the assignment type to "Multiple values". Without a pre-existing definition, the API returns 200 but no data is written.',
    'Metafields Export': 'Metafields Export',
    'Export metafields to Excel': 'Export metafields to Excel',
    'Export metafields from your store to Excel file for backup or re-import': 'Export metafields from your store to Excel file for backup or re-import',
    'Resource Type': 'Resource Type',
    'Select resource type': 'Select resource type',
    'Metafield Type Filter (optional)': 'Metafield Type Filter (optional)',
    'Namespace (optional)': 'Namespace (optional)',
    'Key (optional)': 'Key (optional)',
    'Input namespace (e.g. custom_fields)': 'Input namespace (e.g. custom_fields)',
    'Input key (e.g. material)': 'Input key (e.g. material)',
    'All types (no filter)': 'All types (no filter)',
    'Start Export': 'Start Export',
    'Exporting...': 'Exporting...',
    'Export Progress': 'Export Progress',
    'Task Created': 'Task Created',
    'Fetching Data': 'Fetching Data',
    'Generating File': 'Generating File',
    'Processed': 'Processed',
    'Total metafields': 'Total metafields',
    'Export completed!': 'Export completed!',
    'Click the button below to download the Excel file': 'Click the button below to download the Excel file',
    'Download Excel': 'Download Excel',
    'Export failed': 'Export failed',
    'Cancel Export': 'Cancel Export',
    'Export cancelled': 'Export cancelled',
    'Are you sure you want to cancel this export task?': 'Are you sure you want to cancel this export task?',
    'The export task has been cancelled': 'The export task has been cancelled',
    'Export task cancelled': 'Export task cancelled',
    'Failed to cancel export': 'Failed to cancel export',
    'Instructions': 'Instructions',
    'export_step_1': 'Select the resource type to export (e.g. products, variants)',
    'export_step_2': 'Filter by type, or specify namespace + key for precise export. Leave blank to export all types',
    'export_step_3': 'Click "Start Export" and wait for the task to complete',
    'export_step_4': 'When done, click "Download Excel" — the file can be directly used for re-import',
    'export_warning_title': 'Note: Export time',
    'export_warning_desc': 'Export speed depends on the number of resources and metafields in your store. For large stores, it may take several minutes. Please be patient.',
    'Export task started': 'Export task started',
    'Failed to start export': 'Failed to start export',
    'Please select a resource type': 'Please select a resource type',
    'Store handle not found, please re-login': 'Store handle not found, please re-login',
    'Request failed': 'Request failed',
    'Please fill both namespace and key': 'Please fill both namespace and key',
    'Metafields export requires Basic plan or above': 'Metafields export requires Basic plan or above',

    // Product batch update module
    'Product Batch Management': 'Product Batch Management',
    'Batch import product templates, collections and update products via CSV/Excel': 'Batch import product templates, collections and update products via CSV/Excel',
    'Product Batch Update': 'Product Batch Update',
    'Update Tags Only': 'Update Tags Only',
    'Update Full Product': 'Update Full Product',
    'Update Type': 'Update Type',
    'Start Update': 'Start Update',
    'Product Update Task Status': 'Product Update Task Status',
    'Product Tag Update Tip': 'CSV only needs two columns: product_id (Shopline product ID) and tags (must be lowercase, comma-separated). Other fields will NOT be touched in this mode.',
    'Product Full Update Tip': 'CSV may contain product_id, title, tags, description, spu... Empty columns are skipped. Leave blank any columns you do not want to update.',
    'Product Update Steps': 'Product Update Steps',
    'Download product update template': 'Download product update template',
    'Download Product Tag Template': 'Download Product Tag Template',
    'Download Product Full Template': 'Download Product Full Template',
    'Wait for update completion': 'Wait for update completion',
    'Update product tags or other fields in bulk via CSV/Excel': 'Update product tags or other fields in bulk via CSV/Excel',
    'CSV header normalized to lowercase tags': 'CSV header normalized to lowercase tags'
  }
  


// WEBPACK FOOTER //
// ./src/locales/lang/en-US/index.js